import React from 'react';
import Homepage from '../components/Home';

const Home = () => {
  return (
    <Homepage />
  );
};

export default Home;